export function validatePhoneNumber(phone: string): true | string {
  if (!phone?.trim()) {
    return 'رقم الهاتف مطلوب';
  }

  // Kuwait and Saudi phone number patterns
  const saudiPattern = /^(009665)\d{8}$/;  // Saudi: 0096650xxxxxxx (8 digits after prefix)
  const kuwaitPattern = /^(00965[569])\d{7}$/; // Kuwait: 00965[569]xxxxxxx

  if (!saudiPattern.test(phone) && !kuwaitPattern.test(phone)) {
    return 'رقم الهاتف غير صحيح. يجب أن يكون بالصيغة الدولية:\n- السعودية: 009665xxxxxxx\n- الكويت: 00965[569]xxxxxxx';
  }

  return true;
}